export default __webpack_public_path__ + "static/media/programming-icon.7ca94287.svg";